import React from 'react';
import { func, oneOf, bool, string } from 'prop-types';
import {MediumPrimaryButton} from '@worthy-npm/clarity';

class StickyButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            style: {
                top: props.position === 'top' ? 0 : '',
                bottom: props.position === 'bottom' ? 0 : '',
                transform: this.getProperTransformValue(),
            }
        };

        this.getProperTransformValue = this.getProperTransformValue.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { show } = this.props;

        if (prevProps.show !== show) {
            this.setState({
                style: {
                    ...this.state.style,
                    transform: this.getProperTransformValue(),
                }
            });
        }
    }
    /* Get transform value according to position of sticky btn */
    getProperTransformValue() {
        return this.props.show
            ? 'translate3d(0, 0%, 0)'
            : this.props.position === 'top' ? 'translate3d(0, -100%, 0)' : 'translate3d(0, 100%, 0)';
    }

    render() {
        const { onClick } = this.props;
        const text = <div className="regular-text">{this.props.text}</div> // Should be a Clarity/Regular text comp
        return (
            <div className="sticky-btn" style={this.state.style}>
                {text}
                <MediumPrimaryButton text={this.props.btnText} disabled={false} click={(stopAnimation) => onClick(stopAnimation)}/>
            </div>
        )
    }
}

StickyButton.propTypes = {
    onClick: func.isRequired,
    text: string.isRequired,
    btnText: string.isRequired,
    show: bool.isRequired,
    position: oneOf(['top', 'bottom']),
};

StickyButton.defaultProps = {
    position: 'bottom'
};

export default StickyButton;
